import React from "react"
import firebase from "gatsby-plugin-firebase"

import SignOutButton from "../images/enter-outline.svg"

export default ()=>{
    return(
    <img style = {{cursor:"grab"}}width = "40px" height = "auto" src = {SignOutButton} onClick = {()=>{firebase.auth().signOut()}}/>
    )
}